var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVvin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 123 109.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #5e72eb;\n      }\n\n      .cls-3 {\n        fill: none;\n        opacity: .2;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 18.87,
    y1: 127.49,
    x2: 57.15,
    y2: 3.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5e72eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ff9190"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 78.16,
    y1: 110.29,
    x2: 62.73,
    y2: 52.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ffc296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9190"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m75.17,30.49l-31.3,71.91c-1.07,2.45-4.56,2.4-5.56-.08l-21.15-52.45c-.64-1.57.16-3.36,1.75-3.95l52.45-19.46c2.49-.92,4.87,1.59,3.81,4.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    width: 123,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAABaCAYAAACYNynsAAAACXBIWXMAAAsSAAALEgHS3X78AAAEyklEQVR4nO2bC2/iMBCEnQcUeu3d/f8fSh9AcqrklUajXSf0KE5gPmllJ9ASMrvrtR2SEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEWBnNSi73O9c5/sB1rJoli83XVjpmYaeOH5Ilit04/Yb6+F4UcoR2pHPcfzj6hX1hFrdkzDhh3vsfiqVEdiRyC20Lx41z7UMWENsBHGB49GhfgtgsdEvWgXmijyToOWiHIPKNuxe9ttgotAmI4vZkds4ENwYQ+MtO1JoNBeGNuxW95pjNQpuZwJtsW2pN9JYi20T+siOYHaMTDE7av/txvXaBhqkbI/lL2CewXe6z4A2lbxP507EjOAOLPtCYnnK/gf7qqSU2F2EmtkXyLttzSmkPtgPBWewTCP2R7R366AAsuhftmDXuQvQlRLYn9HO2l5TSL7A9RLilckzhLPRbbs1QeEz19veWIbjwuwvRa4jtRXXviP2aUvqd29cs/DNEdw9iDxTVJjQbi/7hjO9TxRyyKtFrF2hYfW9y1O5zJJvYf0B0jO4eKnKObBb7kO2tEO3HIMV7xZzH4oWvPWZzBY6RjYL/hehGsbv8/3DM5jR+IMEPE9E+p5gz4Y1VpPhuxnuuCafwriCyCf0bItvGcCvcdlCxb8k2zrmtM5XbBPN5Xtzh1Ts2w1vdWwS1xJ6qwF/AUOQ9FWmRWNE8feuc39DfdCR6R+Ljd+DvtWjRlzLP5mgvRZP3P1pyIFyB29C8fZcd5kDTulIxx9O24wUrc7wzV42lpHEUZAf2RFMtXDkzokqZN1JKy7BehuDjyBFb+LxU6FeP8qWIzWkXUywLjOvg3uKIt/FhlMTvCkNCF6T0lpxqThaqRm2xW0f0nm6qwWvf0ZLokappcwwvA+DmS+QA3PcivHUiOBK2muC1xE6B4NH2JYv8QXNlnjd7DoDie1FfckR2hqmaYkrQKoLXKNCwaBmcOTJGiW1uvOeCiqvwDWUDbj1R8DpQeBO5J0eI9tmjvfYohQ/wuVW4tdgjRayl2DZHIS5MoNA7mid7BRQPA9HUiQu8FOx8mfBeJiiNzVOPRzXU3oyaUy8U/ETnB1j+5IINhfbG+jmidxCtUbSfYazngvKcr6H0KBRvnzbkzDenVho3Buc13Jv+nKiOvf5UW0q9KMYIlT0umSanou/ze3pwkg6yVkvbplXm3rUjO8FN5dTegdhRkcTiecYiT1XW3hzee+SJN0W8BaLSA5I3p5bYXKRhRLU0lh+D4sgrlrid6xTRbAAjcADH5Dl+aTdsMUumtSObb6a1fMN5TTpqS07gOUB0LorI0RnXT4Hw0cpeNWqvjXN1zv1UmMde4gxzHGHuujw6J4vOD0GUHma8OUv4RQhOZ3Ac99aaWeyo/x0nKJ2Lxlyveo8efKgu+pJ+/sPFjvcsd8kB0n86QWmImJpX83gerdOnmqIvpniYQXStfP5aThCZ95kjjednivgowm8q+prEjvhpJ4iOseWo9Z5b4/H7oebZ12LuTfOGglRwgkva5AjuWVXuIbIv5dJMMLefnDojGqc1ZlemdC+816buXSRutQiX2PO4xn1SGl85l0S3EEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEJeQUvoHZDJGt+0eMfIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.31,46.26l26.82,61.18c1.07,2.45,4.56,2.39,5.56-.08l20.95-51.96c.71-1.76-.36-3.73-2.22-4.09l-47.77-9.22c-2.39-.46-4.31,1.95-3.33,4.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84,
    cy: 104,
    r: 5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVvin);
export default __webpack_public_path__ + "static/media/logo_vvin.e8a5480e91f0e9c7d3caac5bfb663837.svg";
export { ForwardRef as ReactComponent };